// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subtext[data-v-4861dfee]{display:flex;flex-direction:column}.subtext span[data-v-4861dfee]{font-size:12px;line-height:16px;color:#6c7d87}.img[data-v-4861dfee]{width:24px;height:24px}.cancel-btn[data-v-4861dfee]{border:0;background-color:#01426b;color:#fff;border-radius:30px;padding:2px 10px;margin-top:10px}.d-popup[data-v-4861dfee] .bottom-navigation{top:322px;left:310px}.d-popup[data-v-4861dfee] .body-item{cursor:pointer}", ""]);
// Exports
module.exports = exports;
